import i18n from '../../i18n';

const timeDifference = (current, previous) => {
    const milliSecondsPerMinute = 60 * 1000
    const milliSecondsPerHour = milliSecondsPerMinute * 60
    const milliSecondsPerDay = milliSecondsPerHour * 24
    const milliSecondsPerMonth = milliSecondsPerDay * 30
    const milliSecondsPerYear = milliSecondsPerDay * 365

    const elapsed = current - previous

    if (elapsed < milliSecondsPerMinute / 3) {
        return i18n.t('time_just_now', {defaultValue: 'just now'})
    }

    if (elapsed < milliSecondsPerMinute) {
        return i18n.t('time_less_than_1_min', {defaultValue: 'less than 1 min'})
    } else if (elapsed < milliSecondsPerHour) {
        return i18n.t('time_minutes_short', {defaultValue: '{{count}} min', count: Math.round(elapsed / milliSecondsPerMinute)})
    } else if (elapsed < milliSecondsPerDay) {
        return i18n.t('time_hours_short', {defaultValue: '{{count}} h', count: Math.round(elapsed / milliSecondsPerHour)})
    } else if (elapsed < milliSecondsPerMonth) {
        let days = Math.round(elapsed / milliSecondsPerDay)
        return i18n.t('time_days', {defaultValue: '{{count}} day(s)', count: days})
    } else if (elapsed < milliSecondsPerYear) {
        return i18n.t('time_months_short', {defaultValue: '{{count}} mo', count: Math.round(elapsed / milliSecondsPerMonth)})
    } else {
        return i18n.t('time_years', {defaultValue: '{{count}} years', count: Math.round(elapsed / milliSecondsPerYear)})
    }
}

const timeDifferenceForDate = date => {
    const now = new Date().getTime()
    const updated = new Date(date).getTime()

    return timeDifference(now, updated)
}

export {timeDifference, timeDifferenceForDate}
